import { Dispatch, Action } from 'redux'
import { WorkspaceStorageUploadMessageMapDispatchReturnType } from './types/WorkspaceStorageUploadMessageMapDispatchReturnType'

export const WorkspaceStorageUploadMessageMapDispatch = (
  _dispatch: Dispatch<Action>
): WorkspaceStorageUploadMessageMapDispatchReturnType => {
  return {}
}
